import React from 'react';

const YoutubeIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 361.4 257.7"
    width="361.4"
    height="257.7"
    className={className}
  >
    <path d="M357.8 57.1s-3.6-24.9-14.4-36.1C329.7 6.4 314.2 6.4 307.3 5.7c-50.6-3.6-126.5-3.6-126.5-3.6h-.2s-75.8 0-126.4 3.6c-7 .8-22.5.8-36.2 15.3C7.1 32.1 3.7 57.1 3.7 57.1S0 86.5 0 116v27.6c0 29.4 3.7 58.8 3.7 58.8s3.5 25.1 14.3 36.2c13.8 14.5 31.8 14.1 39.8 15.5 28.9 2.8 122.9 3.7 122.9 3.7s76.1 0 126.7-3.7c7-.9 22.4-.9 36.2-15.4 10.8-11 14.4-36.2 14.4-36.2s3.5-29.3 3.5-58.9V116c-.1-29.5-3.7-58.9-3.7-58.9zM141.9 191V67.8l106.7 61.6L141.9 191z" />
  </svg>
);

export default YoutubeIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Icons/youtube.js